import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';
import { url } from '@/config/urls';
import { dateUtil } from '@functions/dateUtil.js';

export const useServiceApplyStore = defineStore('serviceApply', () => {
  const { formatDateWithSlash } = dateUtil();

  const enifClub = ref(null);
  const barcodeScan = ref(null);

  const mapServiceStatus = (serviceStatusList) => {
    if (!Array.isArray(serviceStatusList)) return;
    enifClub.value = null;
    barcodeScan.value = null;

    serviceStatusList.forEach(item => {
      switch (item.serviceCode) {
        case '01':
          enifClub.value = {
            applied: item.applied,
            appliedDate: formatDateWithSlash(item.appliedDate),
            canceledDate: formatDateWithSlash(item.canceledDate)
          };
          break;
        case '02':
          barcodeScan.value = {
            applied: item.applied,
            appliedDate: item.appliedDate,
            canceledDate: item.canceledDate
          };
          break;
      }
    });

    // バーコードスキャン利用可能チェック
    if (barcodeScan.value) {
      barcodeScan.value.isAvailable = (() => {
        const APPLIED_USING = 2; // 利用中

        // 「利用中」は最優先で利用可能（再申込時はcanceledDateが更新されず古い解約日が残るため）
        if (barcodeScan.value.applied === APPLIED_USING) {
          return true;
        }

        if (!barcodeScan.value.canceledDate) {
          return false;
        }

        let today = new Date();
        let todayYearMonth = Number(today.getFullYear().toString()+(today.getMonth() + 1).toString().padStart(2, "0"));
        let canceledYearMonth = Number(barcodeScan.value.canceledDate.toString().slice(0, 6));

        return todayYearMonth <= canceledYearMonth;
      })();
    }
  };

  const fetchServiceApply = async (apiUrl = url.api.serviceApply.get) => {
    const res = await axios.get(apiUrl);
    mapServiceStatus(res.data.response);
  };

  return {
    enifClub
    , barcodeScan
    , fetchServiceApply
    , mapServiceStatus };
});